export default "__VITE_PUBLIC_ASSET__94145d1c__"